export const NEW_FOLDER_ID = 'NEW';

export type TLocalStorageSidePanelData = {
  favouritesCollapsed: boolean;
  collapsedAccounts: string[];
  collapsedFolders: {
    [accountId: string]: string[];
  };
};
